import React from 'react';
import Layout from '../components/Layout';
import { BookOpen, FileText, ExternalLink, CalendarDays, Users } from 'lucide-react';

const Research: React.FC = () => {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto space-y-8">
        <h2 className="text-2xl font-bold">研究紹介</h2>

        <section className="bg-white p-6 rounded-xl shadow-md space-y-4">
          <h3 className="text-xl font-semibold flex items-center gap-2">
            <BookOpen size={20} /> 調理の特徴と他レシピとの差異に注目したレシピの集合内における相対的な説明の生成
          </h3>
          <p className="text-gray-700">
            「レシピを検索すると、「たくさんレシピが出てきたけど、似たようなタイトルで、どんなレシピか良く分からない！」なんてことありますよね。そこでこの研究では、<strong>どんなレシピかが一目でわかるようなタイトル</strong>を言語モデルを使って生成するということを行っています。
          </p>

          <div className="space-y-1 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <Users size={16} /> 著者：渡邊 磨王斗，莊司 慶行
            </div>
            <div className="flex items-center gap-2">
              <ExternalLink size={16} /> 学会名：DEIM2025 第17回データ工学と情報マネジメントに関するフォーラム（第23回日本データベース学会年次大会）
            </div>
            <div className="flex items-center gap-2">
              <CalendarDays size={16} /> 発表日：2025年2月27日～3月4日
            </div>
            <div className="flex items-center gap-2">
              <FileText size={16} />
              <a
                href="https://pub.confit.atlas.jp/ja/event/deim2025/presentation/5L-01"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                論文掲載ページを見る
              </a>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Research;
